export default __webpack_public_path__ + "static/media/HoneyBees.52754f37.JPG";